import { render, staticRenderFns } from "./SettingsList.vue?vue&type=template&id=ada746ec"
import script from "./SettingsList.vue?vue&type=script&lang=js"
export * from "./SettingsList.vue?vue&type=script&lang=js"
import style0 from "./SettingsList.vue?vue&type=style&index=0&id=ada746ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports